export type FeatureFlagRecord = Partial<Record<FeatureFlag, boolean | undefined>>;

export enum FeatureFlag {
  TheftReportMergeCasesSelectAll = 'theft_report_merge_cases_select_all',
  CaseTrackingShare = 'case_tracking_share',
  DisableReportPortalExportButton = 'disable_report_portal_export_button',
  EnableDiscussions = 'enable_discussions',
  MultipleCancellationsTimelineTable = 'multiple_cancellations_timeline_table',
  EnableLpCameraLinks = 'enable_lp_camera_links',
  EnableNetsuiteMigration = 'enable_netsuite_migration',
}

export type RouteFeatureFlagPayload = {
  mode: 'blacklist' | 'whitelist';
  branchIds: string[] | number[];
};

export type FeatureFlagResult<T> = {
  enabled: boolean;
  payload?: T;
};
